import { render, staticRenderFns } from "./estados_titulacion.vue?vue&type=template&id=39b8ec4a"
import script from "./estados_titulacion.vue?vue&type=script&lang=js"
export * from "./estados_titulacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports